module.exports = __webpack_public_path__ + "static/media/iconeSheduleWhite.c94ce2af.svg";